import Loader from '../../../Loader'
import { ReportBlockBarChartPreview } from './ReportBlockBarChartPreview'

/** @param {import('./ReportBlockBarChart.types').ReportBlockBarChartProps} props */
export function ReportBlockBarChart({ config = { title: '', legend: true }, content = { data: [] }, maxWidth, loading = false }) {
  const data = content?.data || []

  if (loading) {
    return <Loader loading={loading} />
  }

  if (!data) {
    return <p>No Data</p>
  }

  return <ReportBlockBarChartPreview title={config.title} data={data} maxWidth={maxWidth} showLegend={config.legend} />
}
